import { useTranslation } from "react-i18next";
import NormalTitle from "../../components/NormalTitle";
import { SignInForm } from "./components";
import styles from "./style.module.scss";

const Signin = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.signin}>
      <NormalTitle title={t("normal.signIn")} />
      <div className={styles.mainBg}>
        <div className={styles.main}>
          <div className={styles.form}>
            <div className={styles.title}>{t("normal.signIn")}</div>
            <SignInForm />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Signin;
